module.exports = __webpack_public_path__ + "static/media/YM76_3.332fdb0e.jpg";